<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-switch v-model="searchParams.isJiesou" active-text="已报到" active-color="#13ce66" inactive-color="#ff4949"
              @change="list" inactive-text="未报到">
            </el-switch>
          </el-col>
          <el-col :span="12">
            {{ countStr }}
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="45" fixed="left"></el-table-column>
        <el-table-column width="100px" prop="bmtm" label="报名时间">
          <template slot-scope="scope">
            <el-tag type="success" size="mini">{{ scope.row.bmtm }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="110px" prop="sex" label="姓名">
          <template slot-scope="scope">
            {{ scope.row.name }}
            <el-tag v-if="scope.row.sex == '1'" size="mini"> 男 </el-tag>
            <el-tag v-else type="danger" size="mini">女</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="80px" prop="dyer" label="电邀"></el-table-column>
        <el-table-column width="80px" prop="zxer" label="咨询"></el-table-column>
        <el-table-column width="80px" prop="post" label="课程"></el-table-column>
        <el-table-column width="90px" prop="costs" label="学费">

        </el-table-column>

        <el-table-column width="110px" prop="paied" label="缴费">
          <template slot-scope="scope">
            <el-tag type="success" size="mini">{{ scope.row.paied }}</el-tag>
            <el-tag size="mini">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="bmtm"  width="200px" label="交费到账">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.jftm" size="mini">{{ scope.row.jftm }}</el-tag>
            <el-tag v-if="trNoshow()" type="info" v-show="scope.row.jftm" size="mini">{{
              scope.row.cpttpname }}</el-tag>
          </template>
        </el-table-column>

        <!--el-table-column v-if="trNoshow()"  width="80px" prop="costs" label="保证金">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.bzj" type="warn" size="mini">{{ scope.row.bzj }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column  v-if="trNoshow()"  width="80px" prop="btcost" label="补贴">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.btcost" type="warn" size="mini">{{ scope.row.btcost }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column  v-if="trNoshow()"  width="80px" prop="costs" label="实收">
          <template slot-scope="scope">
            <el-tag type="danger" size="mini">{{
              scope.row.costs - (scope.row.btcost ? scope.row.btcost : 0) - (scope.row.bzj ? scope.row.bzj : 0)
            }}</el-tag>
          </template>
        </el-table-column-->
        <el-table-column prop="bmffs"  width="150px" label="交费方式"></el-table-column>
        <el-table-column prop="bmtremark" label="交费备注"></el-table-column>

        

        <el-table-column label="操作" fixed="right" width="240px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" @click="toDetail(scope.$index, scope.row)"
                v-has-permission-code-and="'003000050015'">详情</el-button>
              <el-button size="mini" v-if="scope.row.costs>scope.row.paied" v-has-permission-code-and="'003000050000'"
                @click="toAdd1(scope.$index, scope.row)"> 缴费</el-button>
              <!--el-button size="mini" v-if="!scope.row.cid" v-has-permission-code-and="'003000050035'"
                @click="toAdd2(scope.$index, scope.row)">进班</el-button-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <genj ref="genj"></genj>
    <show ref="show"></show>
    <toclz ref="toclz"></toclz>
  </div>
</template>
<script>

import genj from "./genj.vue";
import toclz from "./toclz.vue";
import show from "./show.vue";
import api from "@/api/stu/stu.js";

export default {
  name: "stu",
  components: {
    genj,
    show,
    toclz
  },
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      selected2: 0,
      isSh: [],
      me: {},
      isJiao: false,
      page: new this.$constant.pageObj(),
      countStr: "",
      dialogVisible: false,
      kpdate: "",
      month: "",
      navi: {},
    };
  },
  methods: {
    trNoshow() {

      if ('ad' == this.me.role || 'mg' == this.me.role) {
        return true  
      } else { 
        return false
      }
    },
    isShowGenjin(row) {

      // 老师或教学总监 -技术跟进
      if ('tr' == this.me.role || 'mgr2' == this.me.role2) {
        return (!row.pjid)
      } else { // -财务跟进
        return (!row.jftm)
      }

    },
    //获取数据
    handleClose() { },

    exportStus() {
      //导出学生
      api.expstus(this.selected.toString(), "学生名单");
    },
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);
      params.noCid = "1"
      api.list(params, (response) => {

        this.listData = response.data;

        if (response.data.navi) {
          // 可以导航的月份
          this.navi = response.data.navi;
          // 解析时间
          this.month = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");
        } else {
          this.month = null
        }

        this.listLoading = false;
      });
    },
    isShow(idx, row) {
      if ("bz" == this.me.role) {
        if (!row.addr) {
          return true;
        }
      }
      if ("tr" == this.me.role) {
        return row.isCan;
      }

      if ("ad" == this.me.role || "mg" == this.me.role) {
        if (!row.jftm) {
          return true;
        }
      }
      return false;
    },
    //教务添加
    toAdd1(index, row) {

      this.$refs.genj.open(row, this.me, 2, "学员跟进缴费");
    },
    toAdd2(index, row) {

      this.$refs.toclz.open(row, this.me, 1, "完成学员交接");
    },
    //去详情
    toDetail(index, row) {
      this.$refs.show.open(row, this.me, row.name + " ~ 交接单");
    },
    //改变选择项
    selectionChange(val) {

      //清空
      this.selected = [];
      this.selected2 = 0;
      let sumVal = 0;
      for (let item of val) {
        this.selected.push(item.id);
        this.selected2 += item.haskaipao ? 1 : 0;
        if (item.btcos) {
          sumVal += (item.costs - item.btcost);
        } else {
          sumVal += item.costs;
        }
        //扣保证金
        if (item.bzj) {
          sumVal -= item.bzj;
        }
      }
      if (this.selected.length > 0) {
        this.countStr =
          "已选择: " +
          this.selected.length +
          " 位学生,实收合计: " +
          sumVal +
          " 元";
      } else {
        this.countStr = "";
      }


    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    //搜索
    search(type) {

    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
    },
  },
  mounted() {
    this.me = this.$caches.user.get();
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

.box {
  display: flex;
}

.box2 {
  display: flex;
  margin: 0px 10PX;
}
</style>